import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AnsprechpartnerPopoverPage } from './ansprechpartner-popover.page';

const routes: Routes = [
  {
    path: '',
    component: AnsprechpartnerPopoverPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AnsprechpartnerPopoverPageRoutingModule {}
